// 导入所有 frame 模块的国际化文件
import { messages as wuyeRegisterMessages } from '@/lang/frame/wuyeRegisterLang.js'
import { messages as addOrgMessages } from '@/lang/frame/addOrgLang.js'
import { messages as deleteOrgMessages } from '@/lang/frame/deleteOrgLang.js'
import { messages as editOrgMessages } from '@/lang/frame/editOrgLang.js'
import { messages as userLoginMessages } from '@/lang/frame/userLoginLang.js'
import { messages as systemInfoMessages } from '@/lang/frame/systemInfoLang.js'
import { messages as deleteStaffPrivilegeMessages } from '@/lang/frame/deleteStaffPrivilegeLang.js'
import { messages as addStaffPrivilegeMessages } from '@/lang/frame/addStaffPrivilegeLang.js'
import { messages as privilegeStaffInfoMessages } from '@/lang/frame/privilegeStaffInfoLang.js'
import { messages as searchStaffMessages } from '@/lang/frame/searchStaffLang.js'
import { messages as staffPrivilegeMessages } from '@/lang/frame/staffPrivilegeLang.js'
import { messages as staffDetailMessages } from '@/lang/frame/staffDetailLang.js'
import { messages as staffMessages } from '@/lang/frame/staffLang.js'
import { messages as ssoMessages } from '@/lang/frame/ssoLang.js'
import { messages as privilegeMessages } from '@/lang/frame/privilegeLang.js'
import { messages as roleMessages } from '@/lang/frame/roleLang.js'
import { messages as roleShopMessages } from '@/lang/frame/roleShopLang.js'
import { messages as roleStaffMessages } from '@/lang/frame/roleStaffLang.js'
import { messages as registerProtocolMessages } from '@/lang/frame/registerProtocolLang.js'
import { messages as registerMessages } from '@/lang/frame/registerLang.js'
import { messages as privilegeGroupMessages } from '@/lang/frame/privilegeGroupLang.js'
import { messages as paymentPoolMessages } from '@/lang/frame/paymentPoolLang.js'
import { messages as orgMessages } from '@/lang/frame/orgLang.js'
import { messages as loginMessages } from '@/lang/frame/loginLang.js'
import { messages as changeStaffPwdMessages } from '@/lang/frame/changeStaffPwdLang.js'
import { messages as addStaffMessages } from '@/lang/frame/addStaffLang.js'
import { messages as auditCommunityManageMessages } from '@/lang/frame/auditCommunityManageLang.js'
import { messages as chooseOrgMessages } from '@/lang/frame/chooseOrgLang.js'
import { messages as resetStaffPwdMessages } from '@/lang/frame/resetStaffPwdLang.js'
import { messages as indexMessages } from '@/lang/frame/indexLang.js'

// 合并所有国际化消息
export const messages = {
  en: {
    ...wuyeRegisterMessages.en,
    ...addOrgMessages.en,
    ...deleteOrgMessages.en,
    ...editOrgMessages.en,
    ...userLoginMessages.en,
    ...systemInfoMessages.en,
    ...deleteStaffPrivilegeMessages.en,
    ...addStaffPrivilegeMessages.en,
    ...privilegeStaffInfoMessages.en,
    ...searchStaffMessages.en,
    ...staffPrivilegeMessages.en,
    ...staffDetailMessages.en,
    ...staffMessages.en,
    ...ssoMessages.en,
    ...privilegeMessages.en,
    ...roleMessages.en,
    ...roleShopMessages.en,
    ...roleStaffMessages.en,
    ...registerProtocolMessages.en,
    ...registerMessages.en,
    ...privilegeGroupMessages.en,
    ...paymentPoolMessages.en,
    ...orgMessages.en,
    ...loginMessages.en,
    ...changeStaffPwdMessages.en,
    ...addStaffMessages.en,
    ...auditCommunityManageMessages.en,
    ...chooseOrgMessages.en,
    ...resetStaffPwdMessages.en,
    ...indexMessages.en
  },
  zh: {
    ...wuyeRegisterMessages.zh,
    ...addOrgMessages.zh,
    ...deleteOrgMessages.zh,
    ...editOrgMessages.zh,
    ...userLoginMessages.zh,
    ...systemInfoMessages.zh,
    ...deleteStaffPrivilegeMessages.zh,
    ...addStaffPrivilegeMessages.zh,
    ...privilegeStaffInfoMessages.zh,
    ...searchStaffMessages.zh,
    ...staffPrivilegeMessages.zh,
    ...staffDetailMessages.zh,
    ...staffMessages.zh,
    ...ssoMessages.zh,
    ...privilegeMessages.zh,
    ...roleMessages.zh,
    ...roleShopMessages.zh,
    ...roleStaffMessages.zh,
    ...registerProtocolMessages.zh,
    ...registerMessages.zh,
    ...privilegeGroupMessages.zh,
    ...paymentPoolMessages.zh,
    ...orgMessages.zh,
    ...loginMessages.zh,
    ...changeStaffPwdMessages.zh,
    ...addStaffMessages.zh,
    ...auditCommunityManageMessages.zh,
    ...chooseOrgMessages.zh,
    ...resetStaffPwdMessages.zh,
    ...indexMessages.zh
  }
} 